import { Injectable } from '@angular/core'
import type { fhirR4 } from '@smile-cdr/fhirts'
import dayjs from 'dayjs'
@Injectable({
  providedIn: 'root'
})
export class UtilService {

  getNameFromResource(resource: fhirR4.Patient | fhirR4.Practitioner | fhirR4.Organization) {
    if (!resource) return '';
    if (resource.resourceType === 'Organization') {
      return (resource).name ?? '';
    }
    const nameToUse = (resource)?.name?.find(name => name?.use === 'official') || (resource as fhirR4.Patient | fhirR4.Practitioner)?.name?.[0]
    const lastName = nameToUse?.family || ''
    const firstName = nameToUse?.given?.join(' ') || ''
    if (lastName.length + firstName.length === 0) return '';
    return `${lastName}, ${firstName}`
  }

  toAgeString(birthdate: string | undefined, now: Date): string {
    let ageString: string
    if (!birthdate) {
      return ''
    }
    const date1 = dayjs(now)
    const date2 = dayjs(birthdate)
    const diffYears = date1.diff(date2, 'year')

    if (diffYears < 1) {
      const diffMonths = date1.diff(date2, 'month')
      if (diffMonths > 1) {
        ageString = `${diffMonths}m`
      }

      const diffWeeks = date1.diff(date2, 'week')
      if (diffWeeks > 1) {
        ageString = `${diffWeeks}w`
      }
      const diffDay = date1.diff(date2, 'day')
      if (diffDay > 0) {
        ageString = `${diffDay}d`
      }
    }
    return ageString || `${Math.floor(diffYears)}y`
  }

  static sortDateTime(a, b) {
    if (typeof a == "string") {
      return a.localeCompare(b);
    }
    return a - b;
  }

}
